<template>
  <div
    :class="{ 'has-logo': showLogo, 'is-collapsed': isCollapse }"
    class="sideWrap"
  >
    <SidebarLogo
      v-if="showLogo"
      :collapse="isCollapse"
    />
    <el-scrollbar wrap-class="scrollbar-wrapper" class="sidebar-scrollbar">
      <el-menu
        :collapse="isCollapse"
        :unique-opened="false"
        :default-active="activeMenu"
        mode="vertical"
        router
      >
        <SidebarItem
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :is-collapse="isCollapse"
        />
      </el-menu>
    </el-scrollbar>

    <!-- 侧边栏底部展开/收起触发条 -->
    <div
      id="sidebar-collapse-trigger"
      class="sidebar-collapse-trigger"
      :title="isCollapse ? '展开菜单' : '收起菜单'"
      @click="toggleSideBar"
    >
      <div class="trigger-icon-wrap">
        <svg
          v-if="!isCollapse"
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="9" y1="3" x2="9" y2="21"></line>
          <path d="m14 9-3 3 3 3"></path>
        </svg>
        <svg
          v-else
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="9" y1="3" x2="9" y2="21"></line>
          <path d="m13 15 3-3-3-3"></path>
        </svg>
      </div>
      <span v-if="!isCollapse" class="trigger-text">收起菜单</span>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import SidebarItem from './SidebarItem.vue'
import SidebarLogo from './SidebarLogo.vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import { AppActionTypes } from '@/store/modules/app/action-types'

// Temporary fix for webpack 5 SCSS export issue
const variables = {
  menuBg: '#ffffff',
  menuText: 'rgba(0,0,0,1)',
  menuActiveText: '#277EFF'
}

export default defineComponent({
  components: {
    SidebarItem,
    SidebarLogo
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const sidebar = computed(() => {
      return store.state.app.sidebar
    })
    const routes = computed(() => {
      return store.state.permission.sidebarRoutes?.length
        ? store.state.permission.sidebarRoutes
        : (store.state.permission.dynamicRoutes[0]?.children || [])
    })
    const showLogo = computed(() => {
      return store.state.settings.showSidebarLogo
    })

    const menuActiveTextColor = computed(() => {
      if (store.state.settings.sidebarTextTheme) {
        return '#57CAEB'
      } else {
        return variables.menuActiveText
      }
    })

    const activeMenu = computed(() => {
      const { meta, path } = route
      if (meta !== null || meta !== undefined) {
        if (meta.activeMenu) {
          return meta.activeMenu
        }
      }
      return path
    })

    const isCollapse = computed(() => {
      return !sidebar.value.opened
    })

    const toggleSideBar = () => {
      store.dispatch(AppActionTypes.ACTION_TOGGLE_SIDEBAR, false)
    }

    return {
      sidebar,
      routes,
      showLogo,
      menuActiveTextColor,
      variables,
      activeMenu,
      isCollapse,
      toggleSideBar
    }
  }
})
</script>

<style lang="scss">
.sidebar-container {
  // reset element-ui css
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }

  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__view {
    height: 100%;
  }

  .el-scrollbar__bar {
    &.is-vertical {
      right: 0px;
    }

    &.is-horizontal {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.sideWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--rail-bg);

  .sidebar-scrollbar {
    flex: 1;
    min-height: 0;
    height: auto;
  }

  .sidebar-collapse-trigger {
    height: 48px;
    min-height: 48px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-top: 1px solid var(--line);
    color: var(--ink-soft);
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;
    background: var(--rail-bg);

    &:hover {
      background: var(--hover-bg);
      color: var(--blue);
    }

    .trigger-icon-wrap {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }

    .trigger-text {
      margin-left: 10px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: inherit;
    }
  }

  &.is-collapsed {
    .sidebar-collapse-trigger {
      padding: 0;
      justify-content: center;

      .trigger-icon-wrap {
        margin: 0;
      }
    }
  }
}

.el-menu {
  border: none;
  height: 100%;
  width: 100% !important;
}
</style>
